// extracted by mini-css-extract-plugin
module.exports = {"errorHandler":"ErrorHandler_errorHandler__3hYqh","title":"ErrorHandler_title__-Napd","actions":"ErrorHandler_actions__18czp","refreshBtn":"ErrorHandler_refreshBtn__2UDIU"};